import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getCurrentTime16j9973nx5x63 as getCurrentTime } from './internal/KLoggingClock.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KLoggingEventClass;
function KLoggingEvent() {
  if (KLoggingEventClass === VOID) {
    class $ {
      static n2g(level, marker, loggerName, message, cause, payload, timestamp) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        payload = payload === VOID ? null : payload;
        timestamp = timestamp === VOID ? getCurrentTime() : timestamp;
        var $this = createThis(this);
        $this.u2f_1 = level;
        $this.v2f_1 = marker;
        $this.w2f_1 = loggerName;
        $this.x2f_1 = message;
        $this.y2f_1 = cause;
        $this.z2f_1 = payload;
        $this.a2g_1 = timestamp;
        return $this;
      }
      static o2g(level, marker, loggerName, eventBuilder) {
        return this.n2g(level, marker, loggerName, eventBuilder.f2g_1, eventBuilder.g2g_1, eventBuilder.h2g_1);
      }
      toString() {
        return 'KLoggingEvent(level=' + this.u2f_1.toString() + ', marker=' + toString(this.v2f_1) + ', loggerName=' + this.w2f_1 + ', message=' + this.x2f_1 + ', cause=' + toString(this.y2f_1) + ', payload=' + toString(this.z2f_1) + ', timestamp=' + this.a2g_1.toString() + ')';
      }
      hashCode() {
        var result = this.u2f_1.hashCode();
        result = imul(result, 31) + (this.v2f_1 == null ? 0 : hashCode(this.v2f_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.w2f_1) | 0;
        result = imul(result, 31) + (this.x2f_1 == null ? 0 : getStringHashCode(this.x2f_1)) | 0;
        result = imul(result, 31) + (this.y2f_1 == null ? 0 : hashCode(this.y2f_1)) | 0;
        result = imul(result, 31) + (this.z2f_1 == null ? 0 : hashCode(this.z2f_1)) | 0;
        result = imul(result, 31) + getBigIntHashCode(this.a2g_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KLoggingEvent()))
          return false;
        var tmp0_other_with_cast = other instanceof KLoggingEvent() ? other : THROW_CCE();
        if (!this.u2f_1.equals(tmp0_other_with_cast.u2f_1))
          return false;
        if (!equals(this.v2f_1, tmp0_other_with_cast.v2f_1))
          return false;
        if (!(this.w2f_1 === tmp0_other_with_cast.w2f_1))
          return false;
        if (!(this.x2f_1 == tmp0_other_with_cast.x2f_1))
          return false;
        if (!equals(this.y2f_1, tmp0_other_with_cast.y2f_1))
          return false;
        if (!equals(this.z2f_1, tmp0_other_with_cast.z2f_1))
          return false;
        if (!(this.a2g_1 === tmp0_other_with_cast.a2g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'KLoggingEvent');
    KLoggingEventClass = $;
  }
  return KLoggingEventClass;
}
//region block: exports
export {
  KLoggingEvent as KLoggingEvent3el01063mcenm,
};
//endregion

//# sourceMappingURL=KLoggingEvent.mjs.map
